import React, { useState, useEffect } from 'react';
import styled, { createGlobalStyle, css } from 'styled-components';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import Tour from 'reactour';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { sendCustomTrackingInfo } from '@panel/commons';
import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';
import useHideBotMarker from '@panel/commons/hooks/useHideBotmarker';
import Loader from '@panel/commons/lib/SimpleLoader';
import Step from './Step';
import commonVideo from '../../assets/videos/onboarding-reputación.mp4';
import cmVideo from '../../assets/videos/onboarding-reputación-CM.mp4';
import ubVideo from '../../assets/videos/onboarding-reputación-UB.mp4';
import brVideo from '../../assets/videos/onboarding-reputación-BR.mp4';

const TourReputationLevel = ({ device, setShowTour, showTour, userLoggedId, levelValue, siteId }) => {
  const { t } = useTranslation();
  const [currentStepId, setCurrentStepId] = useState(1);
  const [loading, setLoading] = useState(true);
  const [impresion, setImpresion] = useState(false);

  useHideBotMarker(showTour);
  const headerMenu = document.getElementById('header-dropdownMenu');
  const stylesHeaderMenuActive = 'opacity: 1;  transform: translateY(0px);  visibility: visible;';

  const handleOnLoadVideo = () => {
    setLoading(false);
  };

  const getVideo = () => {
    const srcVideo = {
      CMBR: cmVideo,
      UBPE: ubVideo,
      IWBR: brVideo,
      WIBR: brVideo
    };
    return srcVideo[siteId] || commonVideo;
  };

  useEffect(() => {
    handleOnLoadVideo();
  }, [loading]);

  useEffect(() => {
    // Se hace click para desplegar el menu de mobile/tablet:
    if (device !== 'desktop' && showTour) {
      document.getElementById('headerMobile-menu').click();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showTour]);

  useEffect(() => {
    if (impresion === false && showTour) {
      sendCustomTrackingInfo({
        event: 'impression_modal',
        content_group: 'Panel',
        content_type: 'Estadisticas',
        user_reputation: levelValue || '-',
        user_id: userLoggedId,
        modal_name: 'Modal Onboarding Reputacion'
      });
      setImpresion(true);
    }
  }, [impresion, levelValue, userLoggedId, showTour]);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStepId]);

  const boxStyle =
    device === 'desktop'
      ? {
          width: '432px',
          marginTop: currentStepId === 2 && '17px'
        }
      : {};

  const getActions = {
    step1: {
      outClick: () => {
        sendCustomTrackingInfo({
          event: 'click_modal',
          content_group: 'Panel',
          content_type: 'Estadisticas',
          user_reputation: levelValue,
          user_id: userLoggedId,
          item_id: 'Salir',
          modal_name: 'Modal Onboarding Reputacion'
        });
        setShowTour(false);
        if (!!headerMenu && device === 'desktop') {
          headerMenu.style = '';
        } else {
          // Se hace click para ocultar el menu de mobile/tablet:
          document.getElementById('headerMobile-menu').click();
        }
      },
      nextClick: () => {
        sendCustomTrackingInfo({
          event: 'click_modal',
          content_group: 'Panel',
          content_type: 'Estadisticas',
          user_reputation: levelValue,
          user_id: userLoggedId,
          item_id: 'Siguiente',
          modal_name: 'Modal Onboarding Reputacion'
        });
        if (!!headerMenu && device === 'desktop') {
          headerMenu.style = stylesHeaderMenuActive;
        }
      }
    },
    step2: {
      prevClick: () => {
        sendCustomTrackingInfo({
          event: 'click_modal',
          content_group: 'Panel',
          content_type: 'Estadisticas',
          user_reputation: levelValue,
          user_id: userLoggedId,
          item_id: 'Anterior',
          modal_name: 'Modal Onboarding Reputacion'
        });
        if (!!headerMenu && device === 'desktop') {
          headerMenu.style = '';
        }
      },
      outClick: () => {
        sendCustomTrackingInfo({
          event: 'click_modal',
          content_group: 'Panel',
          content_type: 'Estadisticas',
          user_reputation: levelValue,
          user_id: userLoggedId,
          item_id: 'Salir',
          modal_name: 'Modal Onboarding Reputacion'
        });
        setShowTour(false);
        if (!!headerMenu && device === 'desktop') {
          headerMenu.style = '';
        } else {
          // Se hace click para ocultar el menu de mobile/tablet:
          document.getElementById('headerMobile-menu').click();
        }
      },
      finishClick: () => {
        sendCustomTrackingInfo({
          event: 'click_modal',
          content_group: 'Panel',
          content_type: 'Estadisticas',
          user_reputation: levelValue,
          user_id: userLoggedId,
          item_id: 'Finalizar',
          modal_name: 'Modal Onboarding Reputacion'
        });
        setShowTour(false);
        if (!!headerMenu && device === 'desktop') {
          headerMenu.style = '';
        } else {
          // Se hace click para ocultar el menu de mobile/tablet:
          document.getElementById('headerMobile-menu').click();
        }
        Cookies.set('reputationTourLevelSeen', true, { expires: 400 });
      }
    }
  };

  const handleOnClose = (step, action) => {
    getActions[step][action]();
    Cookies.set('reputationTourLevelSeen', true, { expires: 400 });
  };

  const tourConfig = [
    {
      style: boxStyle,
      content: (
        <Step
          id={1}
          onClose={() => handleOnClose('step1', 'outClick')}
          title={t('panel.reputacion.tour.title.step1')}
          bodyText={t('panel.reputacion.tour.text.step1')}
          withClose='24px'
          positionClose='absolute'
          colorText='black'
          fontSizeTitle='20px'
          fontWeightTitle='600'
        >
          {loading ? (
            <LoaderWrapper device={device}>
              <Loader />
            </LoaderWrapper>
          ) : (
            <Video device={device} onLoadedData={handleOnLoadVideo} autoPlay muted loop>
              <source src={getVideo()} type='video/mp4' />
              Your browser does not support the video tag.
            </Video>
          )}
        </Step>
      ),
      position: 'bottom'
    },
    {
      style: boxStyle,
      selector: '[data-tour-panel="reputation-level"]',
      highlightedSelectors:
        device === 'desktop'
          ? [
              '[data-tour-panel="reputation-levelName"]',
              '[data-tour-panel="reputation-levelValue"]',
              '[data-tour-panel="reputation-level-II"]',
              '[data-tour-panel="reputation-level-button"]'
            ]
          : [
              '[data-tour-panel="reputation-level"]',
              '[data-tour-panel="reputation-levelValue"]',
              '[data-tour-panel="reputation-levelChevron"]'
            ],
      content: (
        <Step
          id={2}
          onClose={() => handleOnClose('step2', 'outClick')}
          title={t('panel.reputacion.tour.title.step2')}
          bodyText={t('panel.reputacion.tour.text.step2')}
          withClose='24px'
          positionClose='absolute'
          colorText='black'
          fontSizeTitle='20px'
          fontWeightTitle='600'
        />
      ),
      position: 'top'
    }
  ];

  const disableBody = target => disableBodyScroll(target);
  const enableBody = target => enableBodyScroll(target);

  return (
    <>
      <OverrideCss device={device} step={currentStepId} />
      <Tour
        data-panel='panel-tour-container'
        onAfterOpen={disableBody}
        onRequestClose={() => handleOnClose('step2', 'finishClick')}
        onBeforeClose={e => {
          enableBody(e);
          setCurrentStepId(1);
        }}
        showCloseButton={false}
        steps={tourConfig}
        isOpen={showTour}
        rounded={8}
        startAt={0}
        getCurrentStep={curr => setCurrentStepId(curr + 1)}
        disableDotsNavigation
        disableInteraction
        closeWithMask={false}
        showNumber={false}
        nextButton={React.createElement(
          'div',
          {},
          <NavButton
            data-panel='panel-tour-nvaButton-next'
            isNext
            as='div'
            onClick={() => handleOnClose('step1', 'nextClick')}
          >
            {t('panel.reputacion.tour.cta.next')}
          </NavButton>
        )}
        prevButton={React.createElement(
          'div',
          {},
          <NavButton
            data-panel='panel-tour-nvaButton-back'
            as='div'
            onClick={() => handleOnClose('step2', 'prevClick')}
          >
            {t('panel.reputacion.tour.cta.prev')}
          </NavButton>
        )}
        lastStepNextButton={React.createElement(
          'div',
          {},
          <NavButton data-panel='panel-tour-nvaButton-finish' isNext as='div'>
            {t('panel.reputacion.tour.cta.finish')}
          </NavButton>
        )}
        maskClassName='custom-tour-mask'
        maskSpace={10}
      />
    </>
  );
};

const OverrideCss = createGlobalStyle`
[data-tour-elem="controls"]{
  justify-content:space-between;
  margin-top: 16px;
}
.reactour__helper{
  padding: 24px;
  ${({ device, step }) =>
    device !== 'desktop'
      ? css`
          max-width: 100% !important;
          width: 100%;
          position: fixed;
          top: unset;
          left: 0px;
          right: 0px;
          bottom: 0px;
          transform: translate(0px, 0px);
          border-radius: 8px 8px 0 0;
        `
      : css`
          max-width: 432px;
          transform: ${step === 1 && 'translate(657px, 192px)'};
        `};
}
.custom-tour-mask{
  opacity: 0.6;
}
button.reactour__dot{
  background: ${select('midNeutralGray')}!important;
}
button.reactour__dot--is-active{
  background: ${select('midDarkGrayAux')}!important;
}
[data-tour-elem="left-arrow"]:disabled{
  opacity: 0;
  cursor: auto;
}
`;

const NavButton = styled.button`
  height: 40px;
  padding: 0px 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  font-family: Hind;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  background-color: ${select('white')};
  color: ${select('black')};
  ${({ isNext }) =>
    isNext &&
    css`
      background-color: ${getColor('primary')};
      color: ${select('white')};
    `}
`;

const Video = styled.video`
  width: ${({ device }) => (device !== 'mobile' ? '384px' : '100%')};
  height: ${({ device }) => (device === 'desktop' ? '287.49px' : 'auto')};
`;

const LoaderWrapper = styled.div`
  width: ${({ device }) => (device === 'desktop' ? '384px' : '312px')};
  height: ${({ device }) => (device === 'desktop' ? '238px' : '234px')};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default TourReputationLevel;
